import * as React from 'react';
import { IMedia, IGenre, ICity, IVideoclubStat } from '../interfaces';
import Axios, { AxiosResponse } from 'axios';
import config from '../config';
import Favorite from '../components/parts/Favorite';
import { Redirect } from 'react-router';
import Clip from '../components/items/Clip';
import Vote from '../components/parts/Vote';
import Comments from '../components/parts/Comments';
import i18n from '../config/i18next';
import Banner from '../components/parts/Banner';
import Helmet from 'react-helmet';

interface IState {
    media: IMedia,
    isLoading: boolean,
    name: string,
    media_id: number,
    stat: IVideoclubStat[],
    isNotFound: boolean,
}

class ShowBusinessView extends React.Component<any, IState> {
    private _isUnmounted: boolean = false;

    constructor(props: any) {
        super(props);

        this.state = {
            media: null,
            isLoading: true,
            name: this.props.match.params.name,
            media_id: this.props.match.params.media_id,
            isNotFound: false,
            stat: []
        };
    }

    componentWillReceiveProps(props: any) {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "auto"
        });

        this.setState({
            name: props.match.params.name,
            media_id: props.match.params.media_id,
            isLoading: true,
        }, this.componentDidMount);
    }

    async componentDidMount() {
        let response: AxiosResponse = await Axios.get(`${config.site}/${i18n.language}/api/show-business/view?media_id=${this.state.media_id}`);

        if (!this._isUnmounted)
            if (response.data.status == "success") {
                this.setState({
                    media: response.data.media,
                    isLoading: false,
                });
            } else {
                this.setState({
                    isNotFound: true
                });
            }
    }

    componentWillUnmount() {
        this._isUnmounted = true;
    }

    render() {
        return (
            <div className="i-body">
                {this.state.isNotFound && <Redirect to="/not-found" />}
                <Helmet>
                    <title>{"Новости" + " | " + window.location.host.toUpperCase() + " - Медиа портал в TAS-IX"}</title>
                </Helmet>
                <div className="container v-index">
                    <div className="wrapper">

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}

                        {!this.state.isLoading && (<div className="wrap games watch">

                            <div className="row">
                                <div className="col-md-9 col-xs-12">
                                    <div className="left_box pull-left" style={{ zIndex: 1000 }}>
                                        <div className="poster" style={{ borderRadius: 0 }}>
                                            <a href={this.state.media.fullImage}
                                                data-lightbox="image-1"
                                                data-title={this.state.media.fullname}
                                                style={{ display: "block", zIndex: 1000, maxWidth: "208px", height: "calc(100% - 40px)" }}
                                            >
                                                <img src={this.state.media.fullImage} alt={this.state.media.name} />
                                            </a>
                                        </div>

                                        <Vote isShowBusiness media_id={this.state.media_id} />

                                    </div>
                                    <div className="info">
                                        <h3>{this.state.media.name}</h3>
                                        <hr style={{ borderTop: "1px solid #fff" }} />
                                        <ul>
                                            <li>
                                                <span>Дата:</span>
                                                {this.state.media.date}
                                            </li>
                                            <li>
                                                <span>Просмотры:</span>
                                                {this.state.media.reviews}
                                            </li>
                                        </ul>
                                        <div dangerouslySetInnerHTML={{ __html: this.state.media.info }}></div>
                                    </div>
                                </div>
                                <div className="col-md-3 col-xs-12">
                                    <Banner className="banner300" place={19} />


                                </div>
                            </div>
                        </div>)}

                        {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                        <Banner className="banner235" place={20} />

                        <Comments media_id={this.state.media_id} />
                    </div>
                </div>
            </div>
        );
    }
}

export default (ShowBusinessView);